<mat-expansion-panel [id]="panelId" class="main-panel mt-3 overflow-visible" (opened)="handleOpened()" (closed)="handleClosed()" hideToggle="true"
  [expanded]="panelOpenState">
  <mat-expansion-panel-header tabindex="-1" [style.background-color]="panel.color" class="main-header taxanomy-header p-0 mb-2">
    <mat-panel-title class="align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <img *ngIf="image" class="taxanomy-img" [src]="image" [alt]="imageAlt ? imageAlt : 'Category image'" loading="lazy">
        <div *ngIf="!image" class="image-place-holder"></div>
        <h3>{{panel.title}}</h3>
      </div>
      <div class="arrows" tabindex="0">
        <img class="taxanomy-arrow-up" *ngIf="panelOpenState"
        src="../../../../../assets/action-plan-icons/Arrow@2x.png" alt="" loading="lazy">
        <img class="taxanomy-arrow-down" *ngIf="!panelOpenState"
        src="../../../../../assets/action-plan-icons/ArrowDown@2x.png" alt="" loading="lazy">
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <kla-new-action-taxonomy-goals *ngFor="let goal of panel.list" [goal]="goal" [color]="panel.color" [isParentOpen]="panelOpenState" [config]="config">
  </kla-new-action-taxonomy-goals>
</mat-expansion-panel>

